import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { WorkspaceIdRequest } from '../../../../../backend/src/core/request-response';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { AddBotTokenRequest, SendMessageRequest, SlackGate } from '../../../../../backend/src/core/slack/slack.gate';
import { LambdaService } from '../../shared/core/lambda.service';
import { WorkspaceHolderService } from '../workspace/workspace.holder.service';

@Injectable({
  providedIn: 'root',
})
export class SlackService {
  constructor(
    private lambdaService: LambdaService,
    private workspaceHolderService: WorkspaceHolderService
  ) {}

  sendMessage$(channelId: string, blocks: any[]) {
    const request: SendMessageRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      channelId,
      blocks,
    };
    return this.lambdaService.run$(ResourceName.slack, SlackGate.actions.sendMessage, request);
  }

  isConnected$(): Observable<boolean> {
    const request: WorkspaceIdRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
    };

    return this.lambdaService
      .run$(ResourceName.slack, SlackGate.actions.isConnected, request)
      .pipe(map((response) => response.isConnected));
  }

  updateBotToken$(botToken: string) {
    const request: AddBotTokenRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      botToken: botToken,
    };

    return this.lambdaService.run$(ResourceName.slack, SlackGate.actions.updateBotToken, request);
  }
}
